
import type { Config } from '@empathyco/playboard-core-domain'
import type { PropType } from 'vue'

import type { AuditItem } from '../../../models/services/audit'
import { computed, defineComponent } from 'vue'

import { AuditObjectTypeEnum, InstanceServiceIdEnum } from '../../../enums'

import AuditDetails from './audit-details.component.vue'

import ContextualizeServiceAuditDetails from './instance-management/contextualize-service-audit-details.component.vue'
import PlayboardServiceAuditDetails from './instance-management/playboard-service-audit-details.component.vue'
import TaggingServiceAuditDetails from './instance-management/tagging-service-audit-details.component.vue'

export default defineComponent({
  name: 'InstanceManagementAuditDetails',
  components: {
    AuditDetails,
  },
  props: {
    audit: {
      type: Object as PropType<AuditItem<Config>>,
      required: true,
    },
    ignoredFields: {
      type: Array as PropType<Array<string>>,
    },
    messages: {
      type: Object as PropType<Record<string, any>>,
      required: true,
    },
  },
  setup(props: {
    audit: AuditItem<Config>
    ignoredFields: Array<string>
    messages: Record<string, any>
  }) {
    const baseClass = 'epb-instance-management-audit-details'

    const DEFAULT_IGNORED_FIELDS = ['meta', 'filters', 'pivots']
    const PIVOTS_VISIBLE_TYPES: string[] = [AuditObjectTypeEnum.INDEX_CLIENT]

    const ignoredFields = computed(() => {
      const base = props.ignoredFields ?? DEFAULT_IGNORED_FIELDS
      if (PIVOTS_VISIBLE_TYPES.includes(props.audit.payload.objectType as string)) {
        return base.filter(f => f !== 'pivots')
      }
      return base
    })

    const listProps = computed(() => {
      return {
        audit: props.audit,
        ignoredFields: ignoredFields.value,
        messages: props.messages,
      }
    })

    const serviceComponent = computed(() => {
      const typeFn = {
        [InstanceServiceIdEnum.TAGGING]: () => TaggingServiceAuditDetails,
        [InstanceServiceIdEnum.PLAYBOARD]: () => PlayboardServiceAuditDetails,
        [InstanceServiceIdEnum.CONTEXTUALIZE]: () => ContextualizeServiceAuditDetails,
        default: () => undefined,
      }[props.audit.payload.previousState.service]
      return !!typeFn && typeFn()
    })

    return {
      baseClass,
      listProps,
      serviceComponent,
    }
  },
})
